import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil, throttleTime } from 'rxjs/operators';
import { Constanst } from 'src/app/core/constants/constans.component';
import { ApiCallService } from 'src/app/core/services/api-call.service';
import { HelperClassService } from 'src/app/core/services/clase-utilidades.services';

@Component({
  selector: 'app-perfil-usuario',
  templateUrl: './perfil-usuario.component.html',
  styleUrls: ['./perfil-usuario.component.css'],
  providers: [DatePipe]
})
export class PerfilUsuarioComponent implements OnInit {
  private method: string;
  private route: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(public apiCallService: ApiCallService, private helperClassService: HelperClassService, private router: Router, private datePipe: DatePipe) { }

  userFullName: string;
  userEmail: string;
  userProfile: string;
  userphoneNumber: string;
  companyName: string;
  companyRif: string;
  companyphoneNumber: string;
  companyFiscalAddress: string;
  companyEmail: string;
  companyLicenseNumber: string;
  licenseSerial: string;
  licenseFrom: string | null;
  licenseTo: string | null;

  ngOnInit() {
    this.userFullName = '';
    this.userEmail = '';
    this.userProfile = '';
    this.userphoneNumber = '';
    this.companyName = '';
    this.companyRif = '';
    this.companyphoneNumber = '';
    this.companyFiscalAddress = '';
    this.companyLicenseNumber = '';
    this.companyEmail = '';
    this.licenseSerial = '';
    this.licenseFrom = '';
    this.licenseTo = '';
    this.getInfoUser();
  }

  getInfoUser() {
    this.route = '/profile';
    this.method = 'POST';

    this.apiCallService.call$(null, this.route, this.method, true, '', true)
      .pipe(takeUntil(this.destroy$)).subscribe(
        response => {
          if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
            this.userFullName = response.data.fullName;
            this.userEmail = response.data.email;
            this.userProfile = response.data.profileEntity.profileName;
            this.userphoneNumber = response.data.phoneNumber;
            this.companyName = response.data.companyEntity.companyName;
            this.companyRif = response.data.companyEntity.rif;
            this.companyphoneNumber = response.data.companyEntity.phone;
            this.companyFiscalAddress = response.data.companyEntity.fiscalAddress;
            this.companyEmail = response.data.companyEntity.email;
            //this.companyLicenseNumber = response.data.companyEntity.email;

            for (let i = 0; i < response.data.licenseEntities.length; i++) {
              if (!response.data.licenseEntities[i].expired) {
                this.licenseSerial = response.data.licenseEntities[i].serialLicense;
                this.licenseFrom = this.datePipe.transform(response.data.licenseEntities[i].initDate, 'dd/MM/yyyy');
                this.licenseTo = this.datePipe.transform(response.data.licenseEntities[i].endDate, 'dd/MM/yyyy');
              }
            }

            if (this.userphoneNumber === null || this.userphoneNumber.length === 0 || this.userphoneNumber.trim() === '') {
              this.userphoneNumber = 'No indicado';
            }

            if (this.companyEmail === null || this.companyEmail.length === 0 || this.companyEmail.trim() === '') {
              this.companyEmail = 'No indicado';
            }

            this.apiCallService.hideSpinner();
          } else {
            this.apiCallService.hideSpinner();
            this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
            //this.router.navigate(['menu']);
          }
        },
        error => {
          this.apiCallService.hideSpinner();
          this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
          this.router.navigate(['menu']);
        }
      );
  }

  navigateMenu() {
    let viewScreen = (localStorage.getItem(Constanst.STORAGE_DATA_SCREENTYPE) != null ? localStorage.getItem(Constanst.STORAGE_DATA_SCREENTYPE) : Constanst.SCREEN_TYPE_BD);
    if (viewScreen == '1') {
      this.router.navigate(['/' + 'home']);
    } else {
      this.router.navigate(['/' + 'presupuestos']);
    }
  }
}
